import { Link } from "react-router-dom";
import { AiOutlineArrowRight } from "react-icons/ai";

function Button(props) {
    return (
        <>
        {props.link === undefined ?
            <Link
            to={props.route}
            className={props.className}
            aria-label={"Go to " + props.label.split(" ").slice(-1)}>
                {props.label} {props.icon === undefined ? (<span><AiOutlineArrowRight /></span>) : (<span>{props.icon}</span>)}
            </Link>
        :
            <a
            key={props.label.split(" ").slice(-1)}
            href={props.link}
            rel="noreferrer"
            target= "_blank">
            {props.icon === undefined ? (props.label) : (<span>{props.icon}</span>)}
            </a>
        }
        </>
    )
}

export default Button;